const routes = [
  {
    path: '/agreements/policy',
    name: 'privacy-policy',
    component: () => import('./views/PrivacyPolicy.vue'),
    meta: {
      title: 'Политика конфиденциальности',
      layout: 'ui-design',
    },
  },
  {
    path: '/agreements/user-agreement',
    name: 'user-agreement',
    component: () => import('./views/UserAgreement.vue'),
    meta: {
      title: 'Пользовательское соглашение',
      layout: 'ui-design',
    },
  },
  {
    path: '/agreements/user-agreement-vcht',
    name: 'user-agreement-vcht',
    component: () => import('./views/UserAgreementVcht.vue'),
    meta: {
      title: 'Пользовательское соглашение',
      layout: 'ui-design',
    },
  },
];

export default routes;
